<template>
  <div class="burger" @click="toggle" :class="{'is-open': isMenuOpened}">
    <span></span>
    <span></span>
    <span></span>
    <span></span>
  </div>
</template>

<script>
  import './burger.scss'
  import { mapState } from 'vuex'

  export default {
    name: "Burger",
    data() {
      return {
        isOpen: false,
      }
    },
    computed: {
      ...mapState([
        'isMenuOpened'
      ])
    },
    methods: {
      toggle() {
        this.$store.commit('TOGGLE_MENU')
        window.gtag('event', 'click', {
          'event_category': 'main_menu',
          'event_label': 'intro'
        });
        window.ym(86974684, 'reachGoal', 'main_menu/click/intro');
      }
    }
  }
</script>

<style scoped>

</style>
